import { render, staticRenderFns } from "./PQMExternalLinks.vue?vue&type=template&id=77a36751"
import script from "./PQMExternalLinks.vue?vue&type=script&lang=js"
export * from "./PQMExternalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports